import React from 'react';
import { Icon, IconComponent } from './icon';
import src from 'grpn-mx-mixer/dist/images/icons/store.svg';

export const IconStore: IconComponent = props => <Icon {...props} src={src} />;
